import { create } from 'zustand';

// A question queued from outside the panel (the element card's "ask" button).
interface AssistantState {
  pending: string | null;
  ask: (question: string) => void;
  take: () => string | null;
}

export const useAssistantStore = create<AssistantState>((set, get) => ({
  pending: null,
  ask: (pending) => set({ pending }),
  take: () => {
    const q = get().pending;
    if (q) set({ pending: null });
    return q;
  },
}));
